import { shop as EnUsShop } from '../en-us/shop';
import { AgResourceLanguage } from '../types';

export const shop: AgResourceLanguage['shop'] = {
  ...EnUsShop,
  title: 'Tienda AG1',
  category: 'Categoría',
  allProducts: 'Todos los Productos',
  gifts: 'Regalos',
  supplements: 'Suplementos',
  subscriptions: 'Suscripciones',
  accessories: 'Accesorios',
  gear: 'Equipamiento',
  button: {
    addToCart: 'Añadir al Carrito',
    addToNextOrder: 'Añadir al Próximo Pedido',
    subscribe: 'Suscribirse',
    addedToNextOrder: 'Añadido al Próximo Pedido'
  },
  singleSubscription: 'Suscripción Única',
  doubleSubscription: 'Suscripción Doble',
  description30: '30 Porciones',
  description60: '60 Porciones, mejor valor',
  descriptionIndividual30: '30 Porciones Individuales',
  scoopAvailabilityInfo:
    '*Disponible para añadir al carrito cuando haya al menos otro producto en el carrito',
  scoopPrompt: '¿Necesitas una cuchara para tu bolsa? Añádela abajo gratis.'
};
